<template lang="html">
  <div
    class="card-resource"
    :style="{ 'background-image': 'url(' + imageURL + ')' }"
  >
    <div class="cortina"></div>

    <div class="content">
      <h6 class="title" data-aos="fade-right" data-aos-duration="800">
        {{ title }}
      </h6>
      <p class="description" data-aos="fade-right" data-aos-duration="1000">
        {{ description }}
      </p>

      <Button :clickBtn="this.openPopup">{{ buttonText }}</Button>
    </div>
    <ModalList
      :show="modalStatus"
      @updateShow="modalStatus = $event"
      :eventSuccess="this.successPopup"
      :title="title"
      :id="id"
      :data="data"
      coverImg="https://i.ibb.co/MhzbWmw/Footer-Doc.png"
    />
  </div>
</template>
<script>
import Button from "../General/Button.vue";
import ModalList from "../Document/ModalList.vue";

export default {
  components: {
    Button,
    ModalList,
  },
  props: {
    imageURL: String,
    title: String,
    id: Number,
    description: String,
    buttonText: String,
    data: Array,
  },
  data() {
    return {
      modalStatus: false,
    };
  },

  methods: {
    escapeQuestionMark(text) {
      return text.replace(/\?/g, '%3F');
    },

    getFormattedLink() {
      const escapedTitle = this.escapeQuestionMark(this.data[0].title);
      return `/recursos/${escapedTitle}?id=${this.data[0].id}`;
    },
    openPopup() {
      if(this.data.length === 1){
        this.$router.push(this.getFormattedLink());
      }else{
        let nav = document.getElementById("navbarCeed");
        this.modalStatus = true;
        nav.classList.add("display-none");
        localStorage.setItem("status", true);
      }
      // /recursos/ + title"
    },
    successPopup() {
      this.modalStatus = false;
    },
  },
};
</script>
<style lang="css" scoped>
.card-resource {
  height: 420px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  padding: 26px 22px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-end;
  position: relative;
  z-index: auto !important;
  border-radius: 10px;
}
.card-resource .cortina {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, #000000 100%);
  z-index: auto;
  border-radius: 10px;
}
.card-resource .content {
  z-index: 2;
}
.card-resource .content .title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  color: #ffffff;
  margin-bottom: 4px;
}
.card-resource .content .description {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  color: #ffffff;
  margin-bottom: 40px;
  position: relative;
}
.card-resource .content .description::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -12px;
  width: 125px;
  height: 5px;
  background: #ffffff;
}

@media (max-width: 768px) {
  .card-resource {
    height: 280px;
  }
  .card-resource .content .title {
    font-size: 16px;
    line-height: 19px;
  }
  .card-resource .content .description {
    font-size: 14px;
    line-height: 16px;
  }
}
.display-none {
  display: none !important;
}
</style>
